<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              v-icon(color="basic800" :size="24") mdi-close
          v-col.ml-3
            .h6.basic800--text(v-if="bank") {{ $t('update_bank') }}
            .h6.basic800--text(v-else) {{ $t('add_bank') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4
            .bank-id(v-if="$currency.code == 'MYR'")
              p.mb-2.label.basic600--text.text-uppercase.mt-2 {{ $t('select_bank') }}
              v-select.mt-2.p1(
                v-model="bankId"
                solo flat outlined dense hide-details
                height="40" item-value="id"
                :label="$t('bank_name.label')"
                :items="banks" item-text="name"
                :rules="rules.has_quantity" background-color="basic200"
                )

                template(v-slot:selection="data")
                  v-row(align="center")
                    v-col.py-0.shrink
                      v-avatar(size="20")
                        v-img(:src="data.item.image")
                    v-col.py-0
                      p.mb-0 {{ data.item.name }}
                template(v-slot:item="data")
                  v-row(align="center")
                    v-col.py-2.shrink
                      v-avatar(size="40")
                        v-img(:src="data.item.image")
                    v-col.py-2
                      p.mb-0 {{ data.item.name }}
            
            .bank-name(v-else)
              p.mb-2.label.basic600--text.text-uppercase.mt-2 {{ $t('bank_name.label') }}
              v-text-field.mt-2.p1(
                solo flat outlined dense persistent-hint hide-details
                height="40"
                v-model="bankName"
                :label="$t('bank_name.label')"
                :placeholder="$t('bank_name.placeholder')"
                :rules="rules.not_empty" background-color="basic200"
              )

            .account-number
              p.mb-2.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('bank_account_number') }}
              v-text-field.mt-2.p1(
                solo flat outlined dense persistent-hint hide-details
                height="40"
                v-model="accountNumber"
                :label="$t('account_num.label')"
                :placeholder="$t('account_num.placeholder')"
                :rules="rules.not_empty" background-color="basic200"
              )

            .account-name
              p.mb-2.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('bank_account_owner') }}
              v-text-field.mt-2.p1(
                solo flat outlined dense persistent-hint hide-details
                height="40"
                v-model="accountName"
                :label="$t('account_name.label')"
                :placeholder="$t('account_name.placeholder')"
                :rules="rules.not_empty" background-color="basic200"
              )

      v-card-actions
        v-spacer
        v-btn.button-Aa-small(color='grey', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.mr-2.button-AA-medium(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          div.basic100--text(v-if="bank") {{ $t('update') }}
          div.basic100--text(v-else) {{ $t('add') }}

</template>

<script>
export default {
  name: 'UpdateCashPayment',
  props: ['open', 'company', 'bank'],
  data: () => ({
    bankId: null,
    bankName: null,
    accountNumber: null,
    accountName: null,
    accountEnabled: true,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required']
    },
    banks: [
      { id: 1, name: 'Affin Bank', image: require('@/assets/images/fpx/ABB0233.png') },
      { id: 2, name: 'Agrobank', image: require('@/assets/images/fpx/AGRO01.png') },
      { id: 3, name: 'Alliance Bank Malaysia', image: require('@/assets/images/fpx/ABMB0212.png') },
      { id: 4, name: 'AmBank', image: require('@/assets/images/fpx/AMBB0209.png') },
      { id: 5, name: 'CIMB', image: require('@/assets/images/fpx/BCBB0235.png') },
      { id: 6, name: 'Bank Islam Malaysia', image: require('@/assets/images/fpx/BIMB0340.png') },
      { id: 7, name: 'Bank Rakyat', image: require('@/assets/images/fpx/BKRM0602.png') },
      { id: 8, name: 'Bank Muamalat Malaysia', image: require('@/assets/images/fpx/BMMB0341.png') },
      { id: 9, name: 'Bank Simpanan Nasional', image: require('@/assets/images/fpx/BSN0601.png') },
      { id: 10, name: 'Hong Leong Bank', image: require('@/assets/images/fpx/HLB0224.png') },
      { id: 11, name: 'HSBC', image: require('@/assets/images/fpx/HSBC0223.png') },
      { id: 12, name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
      { id: 13, name: 'Maybank', image: require('@/assets/images/fpx/MBB0228.png') },
      { id: 14, name: 'OCBC Bank', image: require('@/assets/images/fpx/OCBC0229.png') },
      { id: 15, name: 'Public Bank', image: require('@/assets/images/fpx/PBB0233.png') },
      { id: 16, name: 'RHB Bank', image: require('@/assets/images/fpx/RHB0218.png') },
      { id: 17, name: 'Standard Chartered', image: require('@/assets/images/fpx/SCB0216.png') },
      { id: 18, name: 'United Overseas Bank', image: require('@/assets/images/fpx/UOB0226.png') },
    ]
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.bank) {
      const selectedBank = this.banks.filter((obj) => {
        return obj.name == this.bank.bank_name
      })
      if (selectedBank[0]) {
        this.bankId = selectedBank[0].id
      } else {
        this.bankName = this.bank.bank_name
      }
      this.accountEnabled = this.bank.enabled
      this.accountNumber = this.bank.bank_account
      this.accountName = this.bank.account_name
    }
  },
  methods: {
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const selectedBank = this.banks.filter((obj) => {
        return obj.id == this.bankId
      })
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('bank_name', this.bankName ? this.bankName : selectedBank[0].name)
      params.set('bank_account', this.accountNumber)
      params.set('enabled', this.accountEnabled)
      params.set('account_name', this.accountName)
      if (this.bank) {
        this.axios.put(`/directpay_creds/${this.bank.id}/`, params)
        .then(resp => {
          console.log(resp)
          this.$emit('edited', resp.data)
          this.showModal = false
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/directpay_creds/`, params)
        .then(resp => {
          console.log(resp)
          this.$emit('added', resp.data)
          this.showModal = false
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "select_bank": "Select bank",
    "bank_account_number": "Bank account number",
    "bank_account_owner": "Bank account owner",
    "bank_name": {
      "label": "Bank name",
      "placeholder": "Write your bank name here"
    },
    "account_num": {
      "label": "Account number",
      "placeholder": "Write your account number here"
    },
    "account_name": {
      "label": "Account owner",
      "placeholder": "Write account owner's name here"
    },
    "disabled": "disabled",
    "enabled": "enabled"
  },
  "id": {
    "select_bank": "Pilih Bank",
    "bank_account_number": "Nomor akun bank",
    "bank_account_owner": "Nama pemilik akun",
    "bank_name": {
      "label": "Nama Bank",
      "placeholder": "Tulis nama bank kamu di sini"
    },
    "account_num": {
      "label": "Nomor Akun",
      "placeholder": "Tulis nomor akun kamu di sini"
    },
    "account_name": {
      "label": "Pemilik akun",
      "placeholder": "Tulis nama pemilik akun di sini"
    },
    "disabled": "noaktif",
    "enabled": "aktif"
  }
}
</i18n>
